import {gql} from '@apollo/client';

export const GET_DELIVERY_TASK_REVIEW_DETAIL = gql`
  query DeliveryTaskReviewQuery($filter: DeliveryReviewDetailInput!) {
    getDeliveryTaskReviewDetail(filter: $filter) {
          orderId
          trackingNumber
          routeName
          isTransferIn
          isMisScannedByOtherDriver
          misScannedDriverName
          misScannedDriverPhone
          misScanTime
          misScanMarkedType
    }
  }
`;

export interface DeliveryReviewDetailInput {
    accountId: number
}

export interface DeliveryReviewDetailResponse {
    getDeliveryTaskReviewDetail: DeliveryReviewDetailType[];
}

export interface DeliveryReviewDetailType {
    orderId: string
    trackingNumber: string
    routeName: string
    isTransferIn: boolean
    isMisScannedByOtherDriver: boolean
    misScannedDriverName: string
    misScannedDriverPhone: string
    misScanTime?: string | null
    misScanMarkedType?: string | null
}



